import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const getRoles = async () => axios.get(Routes.GET_ROLES);

export const useGetRoles = () =>
  useQuery({
    queryKey: [Keys.GET_ROLES_QRY],
    queryFn: getRoles,
    cacheTime: Infinity,
  });
